import { render, staticRenderFns } from "./extraSidebar.vue?vue&type=template&id=4edf41f9"
import script from "./extraSidebar.vue?vue&type=script&lang=js"
export * from "./extraSidebar.vue?vue&type=script&lang=js"
import style0 from "./extraSidebar.vue?vue&type=style&index=0&id=4edf41f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports